import React from 'react'
import { BreadcrumbLink } from 'Components/Shared/BreadCrumb/BreadCrumb'
import SubnavBar from 'Components/Shared/SubnavBar'

type Props = {
  title?: string
  name?: string
  path: string
  onBack?: () => void
}

const Breadcrumbs: React.ComponentType<Props> = props => {
  const { name, title = 'รายการแก้ไข', path, onBack = () => {} } = props

  const breadcrumbs: BreadcrumbLink[] = [
    {
      url: '/construct-plan',
      title: 'Home',
      icon: '/home.png',
      active: true,
      showTitle: false,
    },
    {
      url: '/construct-plan',
      title: 'บอร์ด',
      active: true,
      showTitle: true,
    },
  ]

  if (name) {
    breadcrumbs.push({
      url: path,
      title: title,
      active: true,
      showTitle: true,
      onClick: onBack,
    })

    breadcrumbs.push({
      url: '',
      title: name,
      active: false,
      showTitle: false,
    })
  } else {
    breadcrumbs.push({
      url: path,
      title: title,
      active: false,
      showTitle: false,
    })
  }

  return <SubnavBar breadcrumbs={breadcrumbs} hideSearch={true} />
}

export default Breadcrumbs
